
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/the-re-edit-blog/[slug]",
      function () {
        return require("private-next-pages/the-re-edit-blog/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/the-re-edit-blog/[slug]"])
      });
    }
  